import { atom, getDefaultStore } from 'jotai';

/**
 * Whether the file is rendered inside the dashboard Agent Chat's read-only
 * preview pane (`DashboardChatPreviewGrid`), which mounts the grid in-page
 * beside the chat rather than navigating to a file route.
 *
 * The preview pane draws its own header with the file name, so the app chrome
 * (sidebar, top bar, toolbar, formula bar) is suppressed. Window-global side
 * effects are also gated off while the flag is set — URL rewriting, document
 * title, grid focus stealing, full-page reloads — since the grid is a guest
 * inside a dashboard page it doesn't own.
 */
export const filePreviewModeAtom = atom(false);

/** Set by the preview pane before mounting the grid; cleared when it unmounts. */
export const setFilePreviewMode = (on: boolean): void => {
  getDefaultStore().set(filePreviewModeAtom, on);
};

/**
 * Non-reactive read for imperative code paths (event handlers, loaders).
 * React components that render differently in preview mode should subscribe
 * to `filePreviewModeAtom` instead.
 */
export const isFilePreview = (): boolean => getDefaultStore().get(filePreviewModeAtom);
